export default __webpack_public_path__ + "static/media/double-men.fde90afd.svg";